export default "__VITE_ASSET__B_OATQam__"